var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascot3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 225,
    viewBox: "0 0 152 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5637 47.8233C46.7693 70.763 68.025 84.9702 68.025 84.9702C68.025 84.9702 79.2193 61.9847 73.0137 39.045C66.808 16.1053 45.5524 1.89819 45.5524 1.89819C45.5524 1.89819 34.3581 24.8836 40.5637 47.8233Z",
    fill: "#3F3D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6823 42.8933C66.7106 59.4697 68.7904 84.9514 68.7904 84.9514C68.7904 84.9514 43.262 83.5576 26.2337 66.9812C9.20541 50.4048 7.12549 24.9231 7.12549 24.9231C7.12549 24.9231 32.654 26.3169 49.6823 42.8933Z",
    fill: "#7199FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2544 39.6876C65.8176 60.5187 71.2798 85.4949 71.2798 85.4949C71.2798 85.4949 95.2848 76.6971 106.722 55.8659C118.159 35.0347 112.696 10.0586 112.696 10.0586C112.696 10.0586 88.6913 18.8564 77.2544 39.6876Z",
    fill: "#3F3D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2431 42.4591C88.0166 66.2107 71.8444 86.0123 71.8444 86.0123C71.8444 86.0123 54.4181 67.3049 53.6446 43.5533C52.8711 19.8016 69.0433 0 69.0433 0C69.0433 0 86.4696 18.7074 87.2431 42.4591Z",
    fill: "#7199FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 224.312C111.765 224.312 144 192.077 144 152.312C144 112.548 111.765 80.3125 72 80.3125C32.2355 80.3125 0 112.548 0 152.312C0 192.077 32.2355 224.312 72 224.312Z",
    fill: "#7199FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69 181.312C89.4345 181.312 106 164.747 106 144.312C106 123.878 89.4345 107.312 69 107.312C48.5655 107.312 32 123.878 32 144.312C32 164.747 48.5655 181.312 69 181.312Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70 156C76.6274 156 82 150.628 82 144C82 137.373 76.6274 132 70 132C63.3726 132 58 137.373 58 144C58 150.628 63.3726 156 70 156Z",
    fill: "#3F3D56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascot3);
export default __webpack_public_path__ + "static/media/mascot_3.23c83977dcca2ee58e1695a5b6e12eaf.svg";
export { ForwardRef as ReactComponent };